import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/client/informations')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/dashboard/client/informations"!</div>
}
